import React from "react";
import ToggleBar from "../../commoncomponents/toggleBar";
import { Table } from "react-bootstrap";
import { utcToLocal } from "../../../utils/dateConvert";
import { rounding, getFriendlyHeading } from "../../../utils/math";
import Location from '../../commoncomponents/location';
import ShowIButtonName from "../../commoncomponents/showIButtonName";

function TrackLog(props) {
  const data = (
    <Table responsive striped>
      <thead>
        <tr className="nowwrapTH">
          <th>Created</th>
          <th>Friendly Name</th>
          <th>Name</th>
          <th>Location</th>
          <th>GPS</th>
          <th>Ignition</th>
          <th>Speed</th>
          <th>Direction</th>
          <th>Sensor A</th>
          <th>Temp A</th>
          <th>Temp B</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        {props.trackDataTotal.length > 0 && props.trackDataTotal.map((data, index) => {
          let lastMessage = data.lastMessage || {};
          let gPRMC = lastMessage.gPRMC || {};

          return (
            <tr>
              <td>{utcToLocal(lastMessage.created)}</td>
              <td>{data.friendlyName}</td>
              <td>{data.assetName}
              <br />
              <ShowIButtonName 
                  ibuttonId={data.ibuttonId}
                  serialno={data.serialno} 
                  iButtonName={data.iButtonName}
                />
                </td>
              <td>
                <Location
                  address={`${lastMessage.location}, ${gPRMC.latitude}, ${gPRMC.longitude}`}
                  lat={gPRMC.latitude}
                  lng={gPRMC.longitude}
                />
              </td>
              <td>{lastMessage.gprsOnline ? "Online" : "Offline"}</td>
              <td>{lastMessage.iO3 ? "On" : "Off"}</td>
              <td>{rounding(gPRMC.speed)}</td>
              <td>{getFriendlyHeading(gPRMC.heading)}</td>
              <td>{lastMessage.iO1 ? "On" : "Off"}</td>
              <td>{lastMessage.sensorAValue}</td>
              <td>{lastMessage.sensorBValue}</td>
              <td>{data.status}</td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );

  return (
    <ToggleBar
      caption="Logs"
      // download={handleDownloadExcel}
      icon="fa-building"
      color="#337ab7"
      content={data}
    />
  );
}

export default TrackLog;
